import { Token_Name } from "../common/constants";
import { parseJSON } from "../common/helperFunctions";

export default function authHeader(httpMethod: 'GET'|'POST'|'DELETE', body: string, url: string) {
    const user = parseJSON(localStorage.getItem(Token_Name));
    if (user && user.accessToken) {
      
      const header: any = {
        'method': httpMethod,
        'headers': new Headers({ 
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.accessToken })
      };
      
      if (body && body !== undefined)
        header['body'] = body;

      if (url && url !== undefined)
        header['url'] = url;
      
      return header;

    } else {
      return {};
    }
  }